<template>
<div class="artist container">
  <div v-if="loading" class="columns">
    <div class="profile column is-half is-offset-one-quarter">
      <p class="has-text-centered is-size-5">Laddar ... </p>
    </div>
  </div>
  <div v-if="error" class="has-text-centered">
    <p>{{error}}</p>
    <p v-if="notfound">Sidan kunde inte hittas</p>
  </div>
  <div v-if="!loading && !error" >
    <div class="columns">
      <div class="profile column is-half is-offset-one-quarter">
        <h1 class="has-text-centered is-size-3 is-size-4-mobile">Stöd <br>{{artist.title}}<br><span class="is-size-1 is-size-2-mobile">{{artist.firstName}} {{artist.lastName}}</span></h1>
      </div>
    </div>
    <div v-if="state == 'view'" class="columns is-variable is-5 reverse-row-order">
      <div class="column is-half">
        <div class="box">
        <div style="background: lightgrey; height: 300px;">Film</div> 
        </div>
        <p>Gåvan utbetalas till<br>
        {{artist.firstName}} {{artist.lastName}}, {{artist.city}}</p>
        <p><a v-bind:href="artist.homepage" target="_blank">{{artist.homepage}}</a></p>
      </div>
      <div class="column is-half">
        <h2 class="is-size-4 mb-4">Backa konsten och {{artist.firstName}} {{artist.lastName}}s skapande med en gåva.</h2>
        <form>
          <div class="field">
            <label class="label">Belopp</label>
          <div class="field has-addons">
            <div class="control is-expanded">
              <div class="select is-fullwidth is-large">
                <select v-model="price">
                  <option v-for="option in priceOptions" v-bind:value="option" v-bind:key="option.value">{{option.text}}</option>
                </select>
              </div>
            </div>
            <!--div class="control">
              <a class="button is-large is-static">
                kr/månad
              </a>
            </div-->
          </div>
          </div>
          <div class="field">
            <label class="label">Tidsperiod</label>
            <div class="control">
              <div class="select is-large is-fullwidth">
                <select v-model="months">
                  <option value="1">1 månad</option>
                  <option value="2">2 månader</option>
                  <option value="3">3 månader</option>
                  <option value="6">6 månader</option>
                  <option value="12">12 månader</option>
                  <option value="-1">Tills vidare</option>
                </select>
              </div>
            </div>
          </div>
          <div class="field">
            <label class="label">Kontakt och uppdateringar</label>
            <div class="control">
              <input class="input is-large" type="email" v-model="email" placeholder="namn@doman.se"/>
            </div>
          </div>
          <div class="field">
            <div class="control">
              <label class="checkbox">
              <input type="checkbox"> Jag vill att min e-postadress lagras och används för att ge mig uppdateringar från konstnären.</label>
            </div>
          </div>
          <div class="field">
            <div class="control">
            <button class="button is-primary is-fullwidth is-large" id="checkout-button" v-on:click.prevent="checkout">Ge gåva</button>
            </div>
          </div>
          <p class="has-text-centered">Betalningsuppgifter i nästa steg</p>
        </form>
      </div>
    </div>
    <div v-if="state == 'order'" class="columns">
      <div class="column is-4 is-offset-4">
        <div class="card">
            <div class="card-header">
              <p class="card-header-title">
                Betalningsuppgifter
              </p>
              <a v-on:click="state = 'view'" class="card-header-icon" aria-label="close">
                <span class="icon has-text-grey-light">
                  <i class="fas fa-times" aria-hidden="true"></i>
                </span>
              </a>
            </div>
        <article class="card-content">
          <div class="content">
            
        <form id="subscription-form">
          <div class="field panel-block mb-5">
            <p class="has-text-grey mb-2" v-if="price">Gåvoprenumeration {{price.text}}. <br>
              Avslutas automatiskt efter {{months}} <span v-if="months < 2">månad</span><span v-if="months > 1">månader</span>.</p>
          </div>
          <div class="field" style="border-bottom: 1px solid #ededed;">
            <div class="control">
          <div id="card-element" class="MyCardElement mb-4">
            <!-- Elements will create input elements here -->
          </div>
          </div>
          </div>
          <!-- We'll put the error messages in this element -->
          <div class="field">
            <div id="card-errors" role="alert">{{cardError}}</div>
          </div>
          <div class="field">
            <div class="control">
            <button v-on:click.prevent="payment" type="submit" class="button is-link is-fullwidth mt-5">Bekräfta</button>
            </div>
          </div>
        </form>
        </div>
        </article>
        </div>
      </div>
    </div>
    <div v-if="state == 'confirm'" class="columns">
      <div class="column is-4 is-offset-4">
        <div class="card">
          <div class="card-header">
              <p class="card-header-title">
                Tack för ditt stöd!
              </p>
            </div>
            <div class="card-content">
              <div class="content">
          <h2 class="has-text-centered title is-size-4 is-size-5-mobile">Din gåvoprenumeration är nu aktiv.</h2>
          <p class="has-text-centered"> Tack för att du backar konsten.<br>
          <a v-bind:href="artist.homepage">Besök konstnärens hemsida</a></p>
          <!-- TODO: show links for sharing/inspiring in SoMe. -->
              </div>
            </div>
        </div>
      </div>
    </div>
  </div>

</div>
</template>

<script>
// Set your publishable key: remember to change this to your live publishable key in production
// See your keys here: https://dashboard.stripe.com/account/apikeys
var stripe = Stripe('pk_test_51H36n4HrUpticegQST8GTXdn77obuG9R2cNxJop3kbINJQJ2AV2FVKpylYVbzZH2euSDRFQqp7AoN56b3HvWzb4n00YsnZVeOf'); //eslint-disable-line no-undef
var elements = stripe.elements();
var fontSize = window.innerWidth < 500 ? "17px" : "21px";
var style = {
  base: {
    color: "#32325d",
    fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
    fontSmoothing: "antialiased",
    fontSize: fontSize,
    "::placeholder": {
      color: "#aab7c4"
    }
  },
  invalid: {
    color: "#fa755a",
    iconColor: "#fa755a"
  }
};

export default {
  name: "Artist",
  components: {
  },
  data: function() {
    return {
      loading: false,
      error: null,
      artist: null,
      state: "view", //view|order|confirm
      email: "",
      price: {},
      months: 1,
      customerId: null,
      paymentMethodId: null,
      cardError: ""
    }
  },
  async created() {
    this.fetchData();
    this.priceOptions = [
      {value:"price_1HGBI1HrUpticegQIwo9scxp", text: "100 kr/månad"},
      {value:"price_1HGBI1HrUpticegQabOhP75F", text: "150 kr/månad"},
      {value:"price_1HGBI1HrUpticegQknMUTp70", text: "200 kr/månad"}
    ];
    this.price = this.priceOptions[0];
  },
  computed: {
    priceId() {
      if(this.price) {
        return this.price.value;
      }
      return "";
    }
  },
  methods: {
    async fetchData () {
      this.error = null;
      this.artist = null;
      this.loading = true;
      const fetchedSlug = this.$route.params.slug;
      try {
        let res = await this.$store.dispatch("api/get", `artist?slug=${fetchedSlug}`);
        if (this.$route.params.slug !== fetchedSlug) { 
          return; 
        }
        this.$data.artist = res.data.artist;
        this.priceOptions = [...res.data.priceOptions];
        this.price = this.priceOptions[0];
      } catch(err) {
        if(err.response.status==404) {
          this.notfound = true
        }
        this.error = err.toString()
      }
      this.loading = false;
    },
    async checkout () {
      let res = await this.$http.post("/api/billing/customer", {email: this.email});
      this.customerId = res.data.scustomer.id;
      this.state = "order";
      await this.$nextTick();
      var cardElement = elements.create("card", { style: style });
      cardElement.mount("#card-element");
      return;
    },
    async payment() {
      // Get a reference to a mounted CardElement. Elements knows how
      // to find your CardElement because there can only ever be one of
      // each type of element.
      const cardElement = elements.getElement("card");
      cardElement.on('change', (event) => {
        this.cardError =  event.error ? event.error.message : '';
      });
      // If a previous payment was attempted, get the latest invoice
      const latestInvoicePaymentIntentStatus = localStorage.getItem(
        'latestInvoicePaymentIntentStatus'
      );
      
      const { error, paymentMethod } = await stripe.createPaymentMethod({
        type: 'card',
        card: cardElement,
      });

       if (error) {
          console.log('[createPaymentMethod error]', error);
          //TODO: show/handle error indication in frontend
          this.cardError = error.message;
          return;
        } 
        console.log('[PaymentMethod]', paymentMethod);
        const paymentMethodId = paymentMethod.id;
        if (latestInvoicePaymentIntentStatus === 'requires_payment_method') {
          // Update the payment method and retry invoice payment
          const invoiceId = localStorage.getItem('latestInvoiceId');
          const invoice = await this.$store.dispatch("api/post", {
              url: "billing/retry-invoice", 
              data: {
                customerId: this.customerId,
                paymentMethodId: paymentMethodId,
                invoiceId: invoiceId,
                }
          });
          const paymentIntent = invoice.payment_intent;
          if( paymentIntent.status === 'requires_payment_method' ) {
            stripe.confirmCardPayment(
              paymentIntent.client_secret, 
            { payment_method: paymentMethodId,}
            ).then((result) => {
              if (result.error) {
                // start code flow to handle updating the payment details
                // Display error message in your UI.
                // The card was declined (i.e. insufficient funds, card has expired, etc)
                throw result;
              } else {
                if (result.paymentIntent.status === 'succeeded') {
                  // There's a risk of the customer closing the window before callback
                  // execution. To handle this case, set up a webhook endpoint and
                  // listen to invoice.payment_succeeded. This webhook endpoint
                  // returns an Invoice.
                  return;
                }
              }
            });
          }
        } else {
          // Create the subscription
          await this.createSubscription({ customerId: this.customerId, paymentMethodId: paymentMethodId, priceId: this.priceId });
        }
    },
    async createSubscription({ customerId, paymentMethodId, priceId }) {
      let subscription;
      try {
        const subscriptionConfig = {
          customerId: customerId,
          paymentMethodId: paymentMethodId,
          priceId: priceId,
          months: this.months,
          accountId: this.$data.artist.accountId
        };
        subscription = await this.$http.post("/api/billing/subscription", subscriptionConfig).then((res) => { return res.data;}).catch((err)=>{ throw err.response.data });
        console.log("Subscription obj: ")
        console.log(subscription);
        if (subscription.error) {
          // The card had an error when trying to attach it to a customer
          throw subscription;
        }

        //handlePaymentThatRequiresCustomerAction
        const paymentIntent = subscription.latest_invoice.payment_intent;
        
        if (paymentIntent.status === 'requires_action') {
          let res = await stripe
            .confirmCardPayment(paymentIntent.client_secret, {
              payment_method: paymentMethodId,
            });
          if (res.error) {
            // start code flow to handle updating the payment details
            // Display error message in your UI.
            // The card was declined (i.e. insufficient funds, card has expired, etc)
            throw res;
          } else if (res.paymentIntent.status === 'succeeded') {
            // There's a risk of the customer closing the window before callback
            // execution. To handle this case, set up a webhook endpoint and
            // listen to invoice.payment_succeeded. This webhook endpoint
            // returns an Invoice.
            this.state = "confirm";
            this.cardError = "";
            return;
          }
        }
      } catch(stripeResult) {
        // An error has happened. Display the failure to the user here.
        this.cardError = stripeResult.error ? stripeResult.error.message : "";
      }
      // handleRequiresPaymentMethod
      if(subscription) {
        if (subscription.status === 'active') {
          // subscription is active, no customer actions required.
          this.cardError = ""
          this.state = "confirm";
          return subscription;
        } else if (subscription.latest_invoice.payment_intent.status === 'requires_payment_method') {
          // Using localStorage to store the state of the retry here
          // (feel free to replace with what you prefer)
          // Store the latest invoice ID and status
          localStorage.setItem('latestInvoiceId', subscription.latest_invoice.id);
          localStorage.setItem(
            'latestInvoicePaymentIntentStatus',
            subscription.latest_invoice.payment_intent.status
          );
          throw new Error('Your card was declined.');
        } 
      }
    }

    
  }
  
}
</script>

<style scoped>
.reverse-row-order{
  flex-direction:row-reverse;
}
</style>